<!--
 * @Author: zhaoliang
 * @Date: 2025-07-25 15:21:52
 * @LastEditTime: 2026-02-27 11:43:23
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Home/Components/MarketingNotice/index.vue
 *
-->
<template lang="html">
  <div class="head-notice-wrapper" v-if="showMarketingPop">
    <div class="head-notice-content" v-if="beforeSendUpdates">
      <div class="head-notice-text">
        <span
          ><b>{{ $t('marketing-consent-tips-title') }}</b>
          {{ $t('marketing-consent-tips-desc') }}</span
        >
      </div>
      <div class="head-notice-desc">
        <i18n-t keypath="third-tools-description" tag="p">
          <router-link to="/privacypolicy" target="_blank" class="underline-link">{{
            $t('Privacy-Policy')
          }}</router-link>
          <a
            :href="
              $i18n.locale === 'fr_CA'
                ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
                : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
            "
            target="_blank"
            class="underline-link"
            >{{ $t('visa-privacy-notice') }}</a
          >
          <router-link to="/feedback" class="underline-link">{{
            $t('contact-us-form')
          }}</router-link>
        </i18n-t>
      </div>
      <div class="head-notice-operation">
        <button role="button" class="head-notice-btn normal" @click="handleMaybeLater">
          {{ $t('marketing-consent-tips-later') }}
        </button>
        <button role="button" class="head-notice-btn primary" @click="handleSendUpdates">
          {{ $t('marketing-consent-tips-updates') }}
        </button>
      </div>
    </div>
    <div class="head-notice-content" v-else>
      <div class="head-notice-text">
        <span
          ><img src="~img/icon-selected-green.svg" alt="" /><b>
            {{ $t('marketing-consent-agree-title') }}</b
          >
          {{ $t('marketing-consent-agree-desc') }}
        </span>
      </div>
      <div class="head-notice-operation">
        <button role="button" class="head-notice-btn normal" @click="handleClose">
          {{ $t('marketing-consent-agree-gotit') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'MarketingNotice',
    data() {
      return {
        showMarketingPop: false,
        beforeSendUpdates: true,
      };
    },
    computed: {
      ...mapState(['userInfo', 'isLogin']),
    },
    watch: {
      isLogin: {
        handler(newVal) {
          // 如果未登录，不展示弹窗
          if (!newVal) {
            this.showMarketingPop = false;
            return;
          }
        },
        immediate: true,
      },
    },
    mounted() {
      // setTimeout(() => {
      //   this.showMarketingPop = true;
      // }, 1500);
      if (this.isLogin && localStorage.getItem('needGetMarketingNotice') === '1') {
        this.getMarketingNotice();
      }
    },
    methods: {
      getMarketingNotice() {
        const params = {
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login.getMarketingNotice(params).then(res => {
          if (res.state === '11') {
            this.showMarketingPop = res.data.showMarketingPop;
          } else {
            this.showMarketingPop = false;
          }
        });
      },
      handleMaybeLater() {
        localStorage.setItem('needGetMarketingNotice', '0');
        this.showMarketingPop = false;
        const params = {
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login.updateNotificationTime(params).then(res => {
          if (res.state === '11') {
            // to do
          } else {
            // to do
          }
        });
      },
      handleSendUpdates() {
        localStorage.setItem('needGetMarketingNotice', '0');
        this.$loading.show();
        const params = {
          channel: 2,
          privacySetting: 3,
          emailSwitchStatus: 1,
          pushSwitchStatus: 1,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login
          .updatePrivacySetting(params)
          .then(res => {
            if (res.state === '11') {
              this.beforeSendUpdates = false;
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
      },
      handleClose() {
        this.showMarketingPop = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use '@/assets/css/variables.scss' as *;
  .head-notice-wrapper {
    position: sticky;
    width: 100%;
    // height: 208px;
    background-color: #f5f7f8;
    z-index: 10;
    top: 100px;
    box-sizing: border-box;
    font-family: 'Open Sans', sans-serif;

    .head-notice-content {
      width: 100%;
      // height: 208px;
      padding: 24px 150px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 12px;
      box-sizing: border-box;

      .head-notice-text {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          display: inline-block;
          margin-right: 8px;
          vertical-align: text-bottom;
        }

        span {
          font-size: 20px;
          font-weight: 400;
          color: #163049;
          line-height: 28px;
        }
      }

      .head-notice-desc {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 400;
        color: #667077;
        line-height: 28px;

        .underline-link {
          color: #163049;
          // font-weight: 700;
          text-decoration: underline;
        }
      }

      .head-notice-operation {
        margin-top: 4px;
        width: 100%;
        // margin-left: 16px;
        display: flex;
        align-items: center;
        gap: 12px;

        .head-notice-btn {
          @include font(14px, 600);
          line-height: 20px;
          box-sizing: border-box;
          height: 40px;
          padding: 0px 12px;
          white-space: nowrap;
          border-radius: 6px;
          cursor: pointer;

          &.normal {
            background-color: #ffffff;
            color: #163049;
            border: 1px solid #163049;
          }
          &.primary {
            background-color: #ba9252;
            color: #ffffff;
            border: 1px solid #ba9252;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .head-notice-wrapper {
      height: unset;
      top: 55px;

      .head-notice-content {
        height: unset;
        padding: 24px 24px;
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;

        .head-notice-text {
          display: flex;
          align-items: center;

          img {
            width: 22px;
            height: 22px;
          }

          span {
            font-size: 16px;
            line-height: 24px;
          }
        }

        .head-notice-desc {
          font-size: 14px;
          line-height: 20px;
        }

        .head-notice-operation {
          margin-left: 0px;
          margin-top: 4px;

          .head-notice-btn {
            @include font(12px, 600);
            line-height: 16px;
            height: 32px;
          }
        }
      }
    }
  }
</style>
